<template>
  <div id="page-user-list" class="p-6">
    <div class="header-custome">
      <div>
        <h3>CheckIn Settings</h3>
      </div>
    </div>
    <div class="automatic-checkout-hld">
      <h3>Automatic Check out</h3>
      <div class="settings-enables">
        <p>Automatic Check out time</p>
        <vs-switch color="#00cbff" v-model="isAutoCheckOutEnabled" />
      </div>
      <div class="vx-col md:w-1/4 w-full mt-4 datewrap">
        <flat-pickr
          :config="configdateTimePickerTime"
          name="autoCheckOutTime"
          v-model="checkoutTime"
          class="time-pkr"
        />
      </div>

      <div class="checkout-message-area">
        <label>Check out message</label>
        <vs-textarea v-model="autoCheckOutMessage" />
      </div>
      
      <div class="vx-col md:w-1/4 w-full mt-4">
        <label>Delay Notification to Manager (Minutes)</label><br />
        <vs-input-number disabled v-model="DelayOffsetSeconds" min="1" style ="width:100;display:-webkit-inline-box;" />
      </div>
      <div class="check-out-confirm-Button">
        <vs-button
          color="#d1d3d7"
          type="border"
          class="cancel-line-button mr-2"
          @click="resetData()"
          >CANCEL</vs-button
        >
        <vs-button
          color="#00ccfe"
          type="filled"
          class="add-line-button save-changes-button"
          @click="saveCheckoutSettings()"
          >SAVE CHANGES</vs-button
        >
      </div>
    </div>
  </div>
</template>
 <script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
//store
import moduleCheckinSettingsManagement from "@/store/checkin-settings-management/moduleCheckinSettingsManagement.js";
export default {
  components: {
    "v-select": vSelect,
    flatPickr,
  },
  data() {
    return {
      isAutoCheckOutEnabled: true,
      autoCheckOutMessage: "",
      DelayOffsetSeconds: 30,
      checkoutTime: "19:00",
      configdateTimePickerTime: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true,
      },
    };
  },

  watch: {},

  computed: {},

  methods: {
    resetData() {
      this.isAutoCheckOutEnabled = false;
      this.checkoutTime = "19:00";
      this.autoCheckOutMessage = "";
      this.DelayOffsetSeconds = 30;
    },
    saveCheckoutSettings() {
      this.$vs.loading();

      var data_local = {
        autoCheckOutMessage: this.autoCheckOutMessage,
        checkoutTime: this.checkoutTime,
        isAutoCheckOutEnabled: this.isAutoCheckOutEnabled,
        DelayOffsetSeconds: this.DelayOffsetSeconds
      };

      this.$store
        .dispatch("checkinSettingsManagement/addUpdateSettings", {
          data: data_local,
        })
        .then((res) => {
          this.$vs.loading.close();
          if (res.status == 200) {
            //if (this.checkoutTime != "19:00") {
            this.$store.dispatch(
              "checkinSettingsManagement/UpdateGlobalSchedular"
            );
            //}
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Settings",
              text: "Settings updated successfully.",
            });
          } else if (res.status == 500) {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "Settings",
              text: "Settings not updated.",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            title: "Settings",
            text: "Something went wrong!",
          });
        });
    },
    checkinSettings() {
      this.$vs.loading();
      this.$store
        .dispatch("checkinSettingsManagement/fetchGeoCheckinSettings")
        .then((res) => {
          console.log("res==pg==", res);
          if (res.autoCheckOutMessage) {
            this.autoCheckOutMessage = res.autoCheckOutMessage;
          }
          if (res.checkoutTime) {
            this.checkoutTime = res.checkoutTime;
          }

          if(res.DelayOffsetSeconds){
            this.DelayOffsetSeconds = res.DelayOffsetSeconds;
          }
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.loading.close();
          debugger;
          console.error(err);
        });
    },
  },

  mounted() {},

  created() {
    if (!moduleCheckinSettingsManagement.isRegistered) {
      this.$store.registerModule(
        "checkinSettingsManagement",
        moduleCheckinSettingsManagement
      );
      moduleCheckinSettingsManagement.isRegistered = true;
    }
    this.checkinSettings();
  },
};
</script>